module.exports = __webpack_public_path__ + "onboarding-push.3601b35dbca666613c6efcdf0144bd12.hashedasset.svg";